<template>
    <div>
        <div class="mt-4 mb-5 text-left">
            <p class="text-lg mb-1">¿Olvidaste tu contraseña?</p>
            <p class="text-sm text-muted">Ingrese la dirección de correo electrónico
                asociada con su cuenta y le enviaremos un enlace por correo electrónico para
                restablecer su contraseña.
            </p>
        </div>
        <form @submit.prevent="SEND()">
            <div class="form-group mb-3">
                <small class="input-title">Dirección de correo electrónico</small>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="bi bi-envelope"></i>
                        </span>
                    </div>
                    <input type="email" class="form-control" v-model="data.email" name="email"
                        :class="errors.email ? 'is-invalid' : ''">
                    <small class="invalid-feedback" v-for="(error, index) in errors.email"
                        :key="index">{{ error }}</small>
                </div>
            </div>
            <div class="form-group mb-3">
                <button type="submit" class="btn btn-primary btn-x w-100">
                    <div class="spinner-border spinner-border-sm" role="status"
                        v-if="count == 1">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <span v-else>Has olvidado tu contraseña</span>
                </button>
            </div>
            <div class="form-group">
                <router-link :to="{ name: 'Login' }" class="btn btn-dark btn-x w-100">
                    <span>Atrás para iniciar sesión</span>
                </router-link>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    data() {
        return {
            data: {
                email: '',
            },
            errors: {},
            count: 0
        }
    },
    methods: {
        SEND: function () {
            let vue = this
            vue.count++
            vue.errors = {}
            if (vue.count == 1) {
                axios({ url: '/forget/password', method: 'POST', data: vue.data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.data = {}
                    })
                    .catch((err) => {
                        if (err.response.status !== 422) {
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp) => {
                        vue.count = 0
                    })
            }
        }
    }
};
</script>
  


// WEBPACK FOOTER //
// src/pages/auth/ForgetPassword.vue